import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiMutationHook } from '../../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../../common/queryClient/getMutationFn';
import { CloneAlgorithmsValidFormDataType } from '../schema/types';
import { DataObjectDescriptionVersionUrl } from '../../query/DataObjectDescriptionVersionUrl';
import { AlgorithmBasicType } from '../../algorithms/schema/types';
import { AlgorithmBasicSchema } from '../../algorithms/schema/AlgorithmBasicSchema';

const putAlgorithmClone = (
  id: number,
  algorithmClone: Partial<CloneAlgorithmsValidFormDataType>,
  headers?: HttpHeaders,
) =>
  apiClient
    .put<
      AlgorithmBasicType[]
    >(expand(DataObjectDescriptionVersionUrl.cloneAlgorithms, { id }), algorithmClone, headers ? { headers } : undefined)
    .then((response) => AlgorithmBasicSchema.array().parse(response.data));

export const useMutateCloneAlgorithmsQuery = createApiMutationHook(
  ['clone-algorithms'],
  getMutationFn(undefined, putAlgorithmClone),
);
